export default __webpack_public_path__ + "assets/img/line-awesome.09dc31126068bedb290b1efed5216b26.ttf";